import EventEmitter from 'src/helpers/EventEmitter'
import EventObserver from 'src/helpers/EventObserver'


// classifier examples
// https://docs.google.com/document/d/1LQ-WWDO4Rj-nKG01MLbu9M76RZ2dfe5_daZVJW-D4Yw/edit#heading=h.3baj156husap
//
//
// Glasses Shape Model: ICN9146329484734376905
// result: narrow, rounded or sunglasses
//
//
// Hat Style: ICN2990831661922366797
//
// result: cap, beanie, fedora, sunhat, sunhat_wide, flat_cap, other
//
//
// Female Hairstyle: ICN4175174950732794872
// result: long_straight, long_wavy, medium_wavy, medium_curly, short, short_fringe, tried_up, ponytail, other
//
//
// https://us-central1-automl-image-class-241300.cloudfunctions.net/classify
//
//
// {
//   model:'',
//     base64:''
// }

export const ML_MODEL_KEYS = {
  HAIR_MALE:'HAIR_MALE',
  HAIR_FEMALE:'HAIR_FEMALE',
  GLASSES:'GLASSES',
  HAT:'HAT'
}


export const ML_MODEL = {
  [ML_MODEL_KEYS.HAIR_MALE]: 'ICN3610197096307984001' , //'ICN307714381059879113',
  [ML_MODEL_KEYS.HAIR_FEMALE]: 'ICN1374913216287391539', //'ICN1374821784483988772',
  [ML_MODEL_KEYS.GLASSES]:null,//'ICN9146329484734376905',
  [ML_MODEL_KEYS.HAT]:null//'ICN2990831661922366797'
}

//const POST_URL = "https://us-central1-automl-image-class-241300.cloudfunctions.net/classify"

/*
let _ml_model = ML_MODEL[ml_model_key];
url = "https://automl.googleapis.com/v1beta1/projects/406283522846/locations/us-central1/models/" + _ml_model + ":predict"
 */
const POST_URL = "https://automl.googleapis.com/v1beta1/projects/406283522846/locations/us-central1/models/"
//TODO !!!!!!!!!!!!  move this token to pass-through server after prototype, remove from frontend
const TOKEN = "ya29.c.b0Aaekm1IjYjaMRE4X3iIggY8GwDXNF0ng2cQR7EKrv2TYsK4nbijdhdK-r1TeF3l7B1smA4xJdJ745GIhE3NQXAh6uPz02puHTKpo9mN4i5J2FirsdLysxQgg09py0O_bk5oA_-qSUKsBPHYYaF0m01TNF425WuhRJWHXeOKCrzAVyQbXFBfjuPeHjIQVCE19eByK_SZ1jpM7ATIWEqg3iEpFw89_ulWtSXOReWDeLzD7ErQQxF_ooryAmQyLFEqebZLKyNgjwvcLylBCdhnDhQ0igNHOvvT5GTx9M8bbWf3TFA1XWf4AaNuuXS95kpVLbR8TN4L7ostt6JzxRJNHTgG351KeZQzBtY5jecovtff-hZ5qlcVuzJy5Rz8ghaS_6B_ilXZVwhOaS_0f0pt8h0uQer67sQofZBIojr4lig7R8h-O5MvzjrkrsBIOuZfp5BnbQyahBWUrrOOl0MrYjl93q8S8yMec6IVZe8-plhoUeM_W4xiMw2n-bFIJrWm_3av7qRfV3us-2sWitgwdke5BOF6FFkB3nfFYgr_ZdQ5_j-X84ccFeeJ8p0Io3YcMvi_4qz3SzxZ89m5VUkrXct0Sn1FgJp8aSotWSWFe7iidu50QyQcpscQnjb7lSvZwSU1pnov5OmieaqoSOqi5nYUR_-mYSc6t_Fgd041UyS3-p2leoY_doBeu4S8Wu5ojczkX5cyS4wxiqe-SOZW_vwey2epQbVvsZm20gjl0Wk5l-q7S_17cRovi6r-okVsoh5mi2X2vS2V9jZ_uZ0YM7_gtFF7jipVWaiUYrBRb9IBlenm5Jmr4Jn6zSSzXjMB7oOvtdz7VjyM4J579yaf2QYx7wuR2xOz9Z63RJUS0U5h-k8Q9Yjv-VUmq6_kjs-sJ3ujt78hXlVetmn6SWi1nlU4yZWU1Jr-YvlYJdJ-Jv9kf2fgFaUSUw2dUMBBucgl8p0cb4baM0vJhI13zaQiptzqY9bfUe7OagY2t8mi3mM41csrq-Io2Ub6"

export const EVENTS = {
  NEW_DETECTION:"NEW_DETECTION",
  CURRENT_DETECTION:"CURRENT_DETECTION",
  CURRENT_DETECTIONS_READY:"CURRENT_DETECTIONS_READY"
}


//UTILS
function getConfidence(detectionObj, key){
  let p = detectionObj.payload
  for(let o of p){
    if (o.displayName == key){return o.classification.score}
  }

  return null
}

function getBestConfidenceKey(detectionObj, keySubsetArr){
  let p = detectionObj.payload

  let output = {key:'', confidence:0}
  for(let o of p){
    let c = o.classification.score
    let keyOK = (!keySubsetArr || keySubsetArr.includes(o.displayName))

    if (keyOK && (output.confidence < c)){
      output.confidence = c
      output.key = o.displayName
    }
  }

  return output
}


const getDetectionObj = function(id,  isFemale, keys){
  return {
    id:id,
    keys:keys,
    female:isFemale,
    [ML_MODEL_KEYS.HAIR_MALE]:null,
    [ML_MODEL_KEYS.HAIR_FEMALE]:null,
    [ML_MODEL_KEYS.GLASSES]:null,
    [ML_MODEL_KEYS.HAT]:null,

    get hat(){return this[ML_MODEL_KEYS.HAT]},
    get hair(){return (this.female) ? this[ML_MODEL_KEYS.HAIR_FEMALE] : this[ML_MODEL_KEYS.HAIR_MALE]},
    get glasses(){return this[ML_MODEL_KEYS.GLASSES]},

    get ready(){
      let ready = true
      for(let k in this.keys){
        if (this.keys[k] && !this[k]){ ready = false }
      }
      //debugger
      return ready
    }


  }
}



class AutoMLService {
  get EVENTS(){return EVENTS}

  get currentDetection(){return this.detections[this.currentID]}

  constructor(){
    //mixins
    Object.assign(this, EventEmitter)
    Object.assign(this, EventObserver)

    this.detections = {}
  }

  getDetections(id, base64Image, isFemale, detect = {hair:true, glasses:true, hat:true}){
    let hair = (isFemale) ? ML_MODEL_KEYS.HAIR_FEMALE : ML_MODEL_KEYS.HAIR_MALE

    console.log('getDetections', isFemale, detect);

    this.currentID = id
    if (!this.detections[id]) {this.detections[id] = getDetectionObj(id , isFemale, detect)}

    if(detect.hair) {this._getDetection(id, base64Image, hair)}
    if(detect.glasses) {this._getDetection(id, base64Image, ML_MODEL_KEYS.GLASSES)}
    if(detect.hat) {this._getDetection(id, base64Image, ML_MODEL_KEYS.HAT)}
  }

  _getDetection(id, base64Image, ml_model_key){

    let _id = id;
    let _ml_model_key = ml_model_key
    let _ml_model = ML_MODEL[ml_model_key];

    let xhr = new XMLHttpRequest();
    let url = process.env.VUE_APP_API_URL + "/model"

    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        let json = JSON.parse(xhr.responseText);
        console.log(json)
        json.id = _id
        json.ml_model_key = _ml_model_key
        console.log('NEW AUTO ML_DETECTION', json);

        this.detections[_id][_ml_model_key] = json
        this.emit(EVENTS.NEW_DETECTION , json)

        if(_id === this.currentID){
          console.log('CURRENT ML_DETECTION', json);
          this.emit(EVENTS.CURRENT_DETECTION , json)
        }

        if(_id === this.currentID && this.currentDetection.ready){
          console.log('CURRENT ML_DETECTION READY', this.currentDetection);
          this.emit(EVENTS.CURRENT_DETECTIONS_READY , this.currentDetection)
        }
      }
    };
    let data = JSON.stringify({
      "file": base64Image,
      "model": _ml_model,
    });
    xhr.send(data);
  }

  //UTILS
  getConfidence(detectionObj, key){
    return getConfidence(detectionObj, key)
  }

  getBestConfidenceKey(detectionObj, keySubsetArr){
    return getBestConfidenceKey(detectionObj, keySubsetArr)
  }


}

let autoMLService = new AutoMLService()
export default autoMLService